import { User } from '../models/user.model';
import { UserApiResponse } from '../models-api/user-api.model';
import { ensureStorageUrl } from './api-url.mapper';

export function mapUserFromApi(user: UserApiResponse): User {
  return {
    id: user.id,
    name: user.name,
    firstName: user.first_name,
    lastName: user.last_name,
    fullLegalName: user.full_legal_name,
    profileUsername: user.profile_username,
    email: user.email,
    phone: user.phone,
    gender: user.gender,
    over21: user.over_21,
    location: user.location,
    status: user.status,
    emailVerifiedAt: user.email_verified_at,
    createdAt: user.created_at,
    updatedAt: user.updated_at,
    profileImage: ensureStorageUrl(user.profile_image),
    avatar: ensureStorageUrl(user.avatar),
    roles: user.roles,
    profileComplete: user.profile_complete,
    hasAcceptedCurrentTerms: user.has_accepted_current_terms,
    notificationInAppEnabled: user.notification_in_app_enabled,
    notificationEmailEnabled: user.notification_email_enabled,
    website: user.website,
    reelApproach: user.reel_approach,
    equipment: user.equipment,
    specialties: user.specialties,
    reelStyles: user.reel_styles,
    payoutPreference: user.payout_preference,
    venmoHandle: user.venmo_handle,
    addressLine1: user.address_line1,
    addressLine2: user.address_line2,
    addressCity: user.address_city,
    addressState: user.address_state,
    addressZip: user.address_zip,
    instagramHandle: user.instagram_handle,
    tiktokHandle: user.tiktok_handle,
    youtubeHandle: user.youtube_handle,
    bio: user.bio,
    businessProfile: user.businessProfile,
  };
}

export function mapUserToApi(user: Partial<User>): Partial<UserApiResponse> {
  return {
    id: user.id,
    name: user.name,
    first_name: user.firstName,
    last_name: user.lastName,
    full_legal_name: user.fullLegalName,
    profile_username: user.profileUsername,
    email: user.email,
    phone: user.phone,
    gender: user.gender,
    over_21: user.over21,
    location: user.location,
    status: user.status,
    profile_image: user.profileImage,
    avatar: user.avatar,
    roles: user.roles,
    profile_complete: user.profileComplete,
    notification_in_app_enabled: user.notificationInAppEnabled,
    notification_email_enabled: user.notificationEmailEnabled,
    website: user.website,
    reel_approach: user.reelApproach,
    equipment: user.equipment,
    specialties: user.specialties,
    reel_styles: user.reelStyles,
    payout_preference: user.payoutPreference,
    venmo_handle: user.venmoHandle,
    address_line1: user.addressLine1,
    address_line2: user.addressLine2,
    address_city: user.addressCity,
    address_state: user.addressState,
    address_zip: user.addressZip,
    instagram_handle: user.instagramHandle,
    tiktok_handle: user.tiktokHandle,
    youtube_handle: user.youtubeHandle,
    bio: user.bio,
  };
}
